import {Injectable} from '@angular/core';

declare const window: any;
@Injectable({
  providedIn: 'root',
})
export class BrazeUtil {
  getDeviceId() {
    if (window?.braze) {
      return window.braze.getDeviceId();
    }
    return '';
  }
}
